import { globalIcon } from '../assets/images/login';
import TbhLogoWithText from '../common/TbhLogoWithText';
import SignupForm from '../features/authentication/SignupForm';
import WeAreGlobal from '../features/authentication/WeAreGlobal';
import { useMedia } from '../hooks/useResponsive';
import styles from '../features/authentication/loginForm.module.css';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { registerNetcoreActivity } from '../utils/registerActivity';
const SignupPage = () => {
  const isDesktop = useMedia('(min-width: 977px)');
  ReactGA.initialize('G-1JQ0XJZQGK');

  useEffect(() => {
    document.title = 'TBH Signup | The Business Hub';
    ReactGA.send({ hitType: 'pageview', page: '/signup', title: 'Custom Title' });
  }, []);

  useEffect(() => {
    registerNetcoreActivity({}, 'TBH_SIGN_UP');
  }, []);

  return (
    <div
      style={{
        width: '100vw',
      }}
      className={[styles.loginPage, 'min-h-[100vh] lg:pb-[50px]'].join(' ')}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '40px',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <TbhLogoWithText />
        <div className='flex flex-row gap-[80px]  w-[85%] md:w-[100%] justify-center lg:ml-[15%] lg:justify-start items-start flex-wrap'>
          <SignupForm />
          {isDesktop && (
            <div className='flex-1 pr-[100px] mt-4'>
              <div>
                <WeAreGlobal />
                <div className='flex justify-end mt-[-50px]'>
                  <img src={globalIcon} alt='alt.png' />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
